module.exports = __webpack_public_path__ + "img/knus_thumbnail.e0655479.jpg";